import React from 'react';

import formatNumber from 'helpers/formatNumber';
import pluralize from 'helpers/pluralize';
import getEntityUrl from 'url-constructors/getEntityUrl';

import { DefaultMetaData } from '../EntityMetadata';
import Anchor from 'components/base/Anchor/Anchor';
import useComponentSettings from 'hooks/useComponentSettings';
import { useSelector } from 'react-redux';
import { checkIsExternalUser } from 'redux/reducers/authentication';
import getAllowedRelatedEntities from 'helpers/getAllowedRelatedEntities';
import getInitialSalesType from 'helpers/getInitialSalesType';
import getSchema from 'schemas/componentSettings/browseRelated';
import { TAsyncDispatchResult } from 'types/shared';

const OptionalAnchor = (props: any): JSX.Element =>
  props.to ? <Anchor {...props}>{props.children}</Anchor> : props.children;

const Artist: React.FC<{ entity: any }> = ({ entity }) => {
  const { grouped_track_count, grouped_album_count, type, id } = entity;
  const isExternalUser = useSelector(checkIsExternalUser);
  const allowedEntityTypes = getAllowedRelatedEntities(isExternalUser, type);
  const initialSalesType = getInitialSalesType(isExternalUser);
  const browseSchema = getSchema(initialSalesType, allowedEntityTypes);
  const settingsId = `browse-related-${type}`;
  const [, saveComponentSettings] = useComponentSettings(
    settingsId,
    browseSchema
  );
  const changeBrowseSetting =
    (browseEntityType: string) => (): TAsyncDispatchResult =>
      saveComponentSettings({
        selectedSalesType: initialSalesType ? initialSalesType : 'streaming',
        browseEntityType,
      });

  return (
    <DefaultMetaData>
      <span>
        <OptionalAnchor
          to={
            grouped_track_count > 0
              ? getEntityUrl({
                  entityType: type,
                  entityId: id,
                  topic: 'overview/view',
                })
              : null
          }
          preserveSearch={true}
          onClick={changeBrowseSetting('track')}
          dataPw="anchor-track"
        >
          {grouped_track_count > 0
            ? `${formatNumber(grouped_track_count)} ${pluralize(
                'track',
                grouped_track_count
              )}`
            : 'No tracks'}
        </OptionalAnchor>
      </span>
      <span>
        <OptionalAnchor
          to={
            grouped_album_count > 0
              ? getEntityUrl({
                  entityType: type,
                  entityId: id,
                  topic: 'overview/view',
                })
              : null
          }
          preserveSearch={true}
          onClick={changeBrowseSetting('release')}
          dataPw="anchor-release"
        >
          {grouped_album_count > 0
            ? `${formatNumber(grouped_album_count)} ${pluralize(
                'release',
                grouped_album_count
              )}`
            : 'No releases'}
        </OptionalAnchor>
      </span>
    </DefaultMetaData>
  );
};

export default Artist;
